function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, createContext, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import FullPageLoader from "./FullPageLoader";
var ApplicationLoaderContext = /*#__PURE__*/ createContext(null);
export function useApplicationLoaderContext() {
    return useContext(ApplicationLoaderContext);
}
ApplicationLoaderProvider.propTypes = {
    children: PropTypes.node.isRequired
};
export var hasLocalStorageEnabled = true;
export function setHasLocalStorageEnabled(value) {
    hasLocalStorageEnabled = value;
}
var trueString = "true";
export default function ApplicationLoaderProvider(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(true), 2), isPageLoaderShown = _useState[0], setIsPageLoaderShown = _useState[1];
    useEffect(function() {
        try {
            window.localStorage.setItem("test-localStorage-availability", trueString);
            hasLocalStorageEnabled = window.localStorage.getItem("test-localStorage-availability") === trueString;
            window.localStorage.removeItem("test-localStorage-availability");
        } catch (e) {
            hasLocalStorageEnabled = false;
        }
    }, []);
    return /*#__PURE__*/ React.createElement(ApplicationLoaderContext.Provider, {
        value: {
            setIsPageLoaderShown: setIsPageLoaderShown
        }
    }, /*#__PURE__*/ React.createElement(FullPageLoader, {
        open: isPageLoaderShown
    }), children);
}
